import { FormStep } from "@components/PatientForms/FormContext/types";
import {
  medicationsSchema,
  medicationsValidation,
  setMedicationResponsesToNull,
  handleDeactivateMedications,
} from "@components/PatientForms/categories/Medications";
import {
  providerHistorySchema,
  providerHistoryValidation,
} from "@components/PatientForms/categories/ProviderHistory";
import {
  currentHealthSchema,
  emptyRecentSymptoms,
  reviewOfSystemsValidation,
} from "@components/PatientForms/categories/ReviewOfSystems";
import {
  calculateEpworthScore,
  epworthSleepinessScaleSchema,
  setEpworthToNull,
  sleepMedicineHistoryValidation,
  sleepUpdateSchema,
} from "@components/PatientForms/categories/SleepMedicineHistory";
import {
  socialHistoryValidation,
  socialStatusesSchema,
} from "@components/PatientForms/categories/SocialHistory";

export const steps: FormStep[] = [
  {
    id: "physiology-review",
    title: "Physiology Review",
    category: "reviewOfSystems",
    schema: currentHealthSchema,
    validation: reviewOfSystemsValidation,
    onLoadData: emptyRecentSymptoms,
  },
  {
    id: "sleep-update",
    title: "Sleep Update",
    category: "sleepMedicineHistory",
    schema: sleepUpdateSchema,
    validation: sleepMedicineHistoryValidation,
  },
  {
    id: "epworth-sleepiness-scale",
    title: "Sleep Assessment",
    abbreviation: "Sleep Assmt.",
    category: "sleepMedicineHistory",
    schema: epworthSleepinessScaleSchema,
    validation: sleepMedicineHistoryValidation,
    onLoadData: setEpworthToNull,
    onSubmit: calculateEpworthScore,
  },
  {
    id: "social-statuses",
    title: "Social History",
    category: "socialHistory",
    schema: socialStatusesSchema,
    validation: socialHistoryValidation,
  },
  {
    id: "medications",
    title: "Medications",
    category: "medications",
    schema: medicationsSchema,
    validation: medicationsValidation,
		onLoadData: setMedicationResponsesToNull,
    onSubmit: handleDeactivateMedications,
  },
  // {
  // 	id: "provider-history",
  // 	title: "Provider History",
  // 	category: "providerHistory",
  // 	schema: providerHistorySchema,
  // 	validation: providerHistoryValidation,
  // },
];
